import React, { useEffect, useState } from "react";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import baseUrl from "../../baseUrl";
import Spinner from "../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { parseJwt } from "../../utils/parseJwt";
import "./WriteBlog.css";

const UpdateBlog = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [contentData, setContentData] = useState("");
  const [loading, setLoading] = useState(false);

  const [editorState, setEditorState] = useState();

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/blog/blog-details`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          const contentDataState = ContentState.createFromBlockArray(
            convertFromHTML(response.data.blog.content)
          );
          const editorDataState =
            EditorState.createWithContent(contentDataState);
          setEditorState(editorDataState);
          setTitle(response.data.blog.title);
          setCategory(response.data.blog.category);
          setContentData(response.data.blog.content);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, [id, token]);

  const handleUpdate = (e) => {
    e.preventDefault();
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const content = draftToHtml(rawContentState);

    if (!title || !category || !content) {
      toast.error("Please fill all fields.");
    } else {
      const userId = parseJwt(token).id;

      setLoading(true);
      axios
        .post(
          `${baseUrl}/blog/update-blog`,
          { userId, id, title, category, content },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.success === true) {
            toast.success(response.data.message);
            navigate(`/blog-details/${id}`);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const handleEditorChange = (state) => {
    setEditorState(state);
  };

  console.log(contentData);
  return (
    <>
      {loading && <Spinner />}
      <div className="flex items-center justify-center p-12">
        <div className="mx-auto w-full max-w-[550px]">
          <h1 className="text-3xl pb-3">Update Blog</h1>
          <form onSubmit={handleUpdate}>
            <div className="mb-5">
              <label
                htmlFor="name"
                className="mb-3 block text-base font-medium text-[#07074D]"
              >
                Title
              </label>
              <input
                type="text"
                name="title"
                id="title"
                placeholder="Blog Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium  outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div>
            <div className="mb-5">
              <label
                htmlFor="countries"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Select a Category
              </label>
              <select
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                id="category"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              >
                <option name="category" value="">
                  Choose a Category
                </option>
                <option name="category" value="Technology">
                  Technology
                </option>
                <option name="category" value="Gadgets">
                  Gadgets
                </option>
                <option name="category" value="Finance">
                  Finance
                </option>
                <option name="category" value="Others">
                  Others
                </option>
              </select>
            </div>
            <div className="mb-5">
              <label
                htmlFor="message"
                className="mb-3 block text-base font-medium text-[#07074D]"
              >
                Content
              </label>

              <Editor
                stripPastedStyles={true}
                editorState={editorState}
                wrapperClassName="wrapper mb-3"
                editorClassName="editor"
                onEditorStateChange={handleEditorChange}
              />
            </div>
            <div>
              <button className="hover:shadow-form rounded-md bg-[#6A64F1] py-3 px-8 text-base font-semibold text-white outline-none">
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateBlog;
